import { machine } from 'local/test/machine';
import Button from '@internetstiftelsen/styleguide/dist/atoms/button/Button';
import { open } from '@internetstiftelsen/styleguide/dist/molecules/modal/modal';

const { i18n } = window.bredbandskollen;

class SupportForm {
	constructor() {
		this.element = document.getElementById('supportModal');

		if (!this.element) {
			return;
		}

		this.form = document.getElementById('supportForm');
		this.content = document.getElementById('supportModalContent');
		this.url = 'https://frontend.bredbandskollen.se/api/support';
		this.email = document.getElementById('supportFormEmail');
		this.message = document.getElementById('supportFormMessage');
		this.name = document.getElementById('supportFormName');
		this.key = document.getElementById('supportFormKey');
		this.ticket = document.getElementById('supportFormTicket');
		this.button = new Button(document.getElementById('supportFormButton'));
		this.error = document.getElementById('supportFormError');

		this.attach();
	}

	attach() {
		this.form.addEventListener('submit', (e) => this.submit(e));

		this.key.value = machine.data.hashkey;

		machine.on('data', (data) => {
			if ('hashkey' in data) {
				this.key.value = data.hashkey;
			}

			if ('ticket' in data || ('report' in data && data.report)) {
				this.ticket.value = data.ticket || data.report.ticket;
			}
		});
	}

	submit(e) {
		e.preventDefault();

		this.button.start();
		this.error.classList.add('is-hidden');

		const data = {
			name: this.name.value,
			from: this.email.value,
			message: this.message.value,
			key: this.key.value,
			ticket: this.ticket.value,
			fakemail: '',
			log: '',
		};

		fetch(this.url, {
			method: 'POST',
			body: JSON.stringify(data),
			headers: {
				Accept: 'application/json',
			},
		})
			.then((response) => response.json())
			.then(() => {
				open(document.getElementById('supportModalSuccess'), {
					replaceCurrent: true,
				});
			})
			.catch((error) => {
				console.error(error);

				this.error.classList.remove('is-hidden');
				this.error.innerHTML = i18n.somethingWentWrong;
			})
			.finally(() => {
				this.button.stop();
			});
	}
}

export default new SupportForm();
